import { ComposedTheme, createUseStyles } from '@glu/theming';

interface IExtendedTheme extends ComposedTheme {
  pageHeader: {
    background: string;
    color: string;
    heightNum: number;
  };
}

const styles = ({
  pageHeader: { background, color, heightNum },
  palette: {
    colors: { white }
  },
  spacing: { unit },
  typography: { fontSize }
}: IExtendedTheme) => ({
  '@global': {
    body: {
      '& ul[class^="dropdownList"]': {
        backgroundColor: white
      },
      '& div[class^="menuActionsWrapper"]': {
        backgroundColor: white
      }
    }
  },
  app: {
    maxWidth: 320 * unit,
    paddingLeft: 8.5 * unit,
    [`@media only screen and (max-width: 600px)`]: {
      paddingLeft: 0,
      paddingTop: 7 * unit
    }
  },
  container: {
    position: 'relative',
    display: 'flex',
    flex: 1
  },
  skipLink: {
    background,
    color,
    fontSize,
    left: 8.5 * unit,
    opacity: 0,
    padding: [0.2 * heightNum, 7.5 * unit],
    position: 'fixed',
    top: 0,
    zIndex: 0,
    '&:active, &:focus, &:hover': {
      background: `${background} !important`,
      color,
      opacity: 1,
      zIndex: 999
    },
    '&:visited': {
      background,
      color,
      opacity: 0,
      zIndex: 0
    }
  }
});

export default createUseStyles(styles);
